import React from 'react';
import { useSelector } from 'react-redux';
import { Image } from 'semantic-ui-react';
import { getAssets } from '../../../selectors';

const ItemImage = ({ src, ...props }) => {
    const { dishPlaceholder } = useSelector(getAssets);

    return <Image style={{ objectFit: 'contain' }} src={src || dishPlaceholder} {...props} />;
};

export default ItemImage;
